<template>
  <div>
    <div>
      <box :title="$t('Templates')">
        <div class="pa-3 d-flex flex-column">
          <div class="mb-1">
            <span>انتخاب قالب : </span>
            <v-btn
              :color="$vuetify.theme.dark ? '' : 'primary'"
              outlined
              @click="changeTheme"
              >{{ themeName || "قالب پیشفرض" }}</v-btn
            >
          </div>
          <!-- <div class="d-flex my-2">
          <span class="center">نوع ورود به سیستم:</span>
          <v-radio-group
            hide-details=""
            v-model="rblLoginType"
            class="ma-0"
            row
          >
            <v-radio label="از طریق Active Directory" :value="1"></v-radio>
            <v-radio label="ورود دستی" :value="0"></v-radio>
          </v-radio-group>
        </div> -->

          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="btnSaveClick">ذخیره قالب</v-btn>
          </div>
        </div>
      </box>
      <theme-changer ref="ThemeChanger" @change="themeChanged" />
    </div>

    <div class="WebSettings mt-2">
      <box :title="$t('nav-settings')">
        <div class="pa-2">
          <span>مجوز درخواست های مرخصی:</span>
          <v-row>
            <v-col
              class="pa-0"
              cols="12"
              sm="6"
              v-for="(item, index) in vacationTypes"
              :key="index"
            >
              <v-checkbox
                multiple
                hide-details
                :value="item.CODE"
                :label="item.NAME"
                v-model="selectedVacationTypes"
                class="checkbox-rtl"
              />
            </v-col>
          </v-row>
          <v-divider class="my-2" />
          <span>مجوز درخواست های ماموریت:</span>
          <v-row>
            <v-col
              class="pa-0"
              cols="12"
              sm="6"
              v-for="(item, index) in missionTypes"
              :key="index"
            >
              <v-checkbox
                multiple
                hide-details
                :value="item.CODE"
                :label="item.NAME"
                v-model="selectedMissionTypes"
                class="checkbox-rtl"
              />
            </v-col>
          </v-row>

          <!-- <v-divider class="my-2" />
            <span>تنظیمات رمز عبور:</span>
            <v-row>
              <span class="center"> تغییر رمز پس از گذشت</span>
              <v-text-field
                placeholder="0"
                class="smallTextField mx-2"
                dense
                solo
                hide-details=""
                v-model="changePasswordAfterDays"
              />
              <span class="center">
              روز، الزامی باشد .</span
              >
                <v-col
                    class="pa-0"
                    cols="12"
                    sm="12"
                    >



                <v-checkbox
                  dense
                  hide-details="true"
                  
                  v-model="hardPassword"
                  @click.stop=""
                  class="checkbox-rtl text"
                  label="الزام در استفاده از کاراکتر خاص همچنین استفاده از حداقل یک حرف بزرگ با طول رمز حداقل 8 حرف باشد  "
                />
                 </v-col>
              </v-row> -->

          <v-divider class="my-3" />

          <div class="d-flex">
            <span class="center">شهر پیش فرض:</span>
            <v-select
              hide-details
              v-model="selectedCity"
              :items="missionCities"
              :label="$t('cityName')"
              item-text="Name"
              item-value="Code"
              return-object
              dense
              solo
              class="my-auto py-0"
            ></v-select>
          </div>

          <v-row>
            <v-col
              class="pa-0"
              cols="12"
              sm="12"
              v-for="(item, index) in settingsDetailsList"
              :key="index"
            >
              <v-checkbox
                hide-details
                :value="item.CODE"
                :label="item.Name"
                v-model="settingsDetailsModelList[item.Model]"
                class="checkbox-rtl"
              />
            </v-col>
          </v-row>

          <v-divider class="my-3" />

          <div class="d-flex">
            <span class="center">از</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtVacationPreDays"
            />
            <span class="center">روز قبل از شروع مرخصی تا</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtVacationNextDays"
            />
            <span class="center"
              >روز بعد از تاریخ پایان مرخصی، عملیات درخواست مرخصی انجام
              شود</span
            >
          </div>

          <div class="d-flex mt-2">
            <span class="center">از</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtMissionPreDays"
            />
            <span class="center">روز قبل از شروع ماموریت تا</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtMissionNextDays"
            />
            <span class="center"
              >روز بعد از تاریخ پایان ماموریت، عملیات درخواست ماموریت انجام
              شود</span
            >
          </div>

          <div class="d-flex mt-2">
            <span class="center">از</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtExtraWorkPreDay"
            />
            <span class="center">روز قبل از شروع اضافه کار تا</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtExtraWorkNextDay"
            />
            <span class="center"
              >روز بعد از تاریخ پایان اضافه کار، عملیات درخواست اضافه کار انجام
              شود</span
            >
          </div>

          <div class="d-flex mt-2">
            <span class="center">تا</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtIoNextDay"
            />
            <span class="center"
              >روز بعد از تاریخ مورد نظر عملیات برگه ورود و خروج انجام شود</span
            >
          </div>

          <v-divider class="my-3" />

          <div class="d-flex mt-2">
            <span class="center">
              مهلت ارسال درخواست اضافه کار در روز های کاری از ساعت</span
            >
            <dialog-time-picker
              class="mx-2"
              :label="$t('time') + ':'"
              :initTime="txtExtraWorkWorkDaysLimitationStartTime"
              @dateResult="ExtraWorkWorkDaysLimitationStartTime"
            />
            <span class="center">تا ساعت</span>
            <dialog-time-picker
              class="mx-2"
              :label="$t('time') + ':'"
              :initTime="txtExtraWorkWorkDaysLimitationEndTime"
              @dateResult="ExtraWorkWorkDaysLimitationEndTime"
            />
            <span class="center"> خواهد بود </span>
          </div>

          <div class="d-flex mt-2">
            <span class="center">
              مهلت ارسال درخواست اضافه کار در روز های تعطیل رسمی از ساعت</span
            >

            <dialog-time-picker
              class="mx-2"
              :label="$t('time') + ':'"
              :initTime="txtExtraWorkOffDaysLimitationStartTime"
              @dateResult="ExtraWorkOffDaysLimitationStartTime"
            />
            <span class="center">تا ساعت</span>
            <dialog-time-picker
              class="mx-2"
              :label="$t('time') + ':'"
              :initTime="txtExtraWorkOffDaysLimitationEndTime"
              @dateResult="ExtraWorkOffDaysLimitationEndTime"
            />
            <span class="center"> خواهد بود </span>
          </div>

          <div class="d-flex mt-2">
            <span class="center">
              مهلت ارسال درخواست اضافه کار در روز های تعطیل توافقی از ساعت</span
            >
            <dialog-time-picker
              class="mx-2"
              :label="$t('time') + ':'"
              :initTime="txtExtraWorkAgreementOffDaysLimitationStartTime"
              @dateResult="ExtraWorkAgreementOffDaysLimitationStartTime"
            />
            <span class="center">تا ساعت</span>
            <dialog-time-picker
              class="mx-2"
              :label="$t('time') + ':'"
              :initTime="txtExtraWorkAgreementOffDaysLimitationEndTime"
              @dateResult="ExtraWorkAgreementOffDaysLimitationEndTime"
            />
            <span class="center"> خواهد بود </span>
          </div>

          <v-divider class="my-3" />

          <div class="d-flex mt-2">
            <span class="center">
              مهلت ارسال درخواست ماموریت در روز های کاری از ساعت</span
            >
            <dialog-time-picker
              class="mx-2"
              :label="$t('time') + ':'"
              :initTime="txtMissionsWorkDaysLimitationStartTime"
              @dateResult="MissionsWorkDaysLimitationStartTime"
            />
            <span class="center">تا ساعت</span>
            <dialog-time-picker
              class="mx-2"
              :label="$t('time') + ':'"
              :initTime="txtMissionsWorkDaysLimitationEndTime"
              @dateResult="MissionsWorkDaysLimitationEndTime"
            />
            <span class="center"> خواهد بود </span>
          </div>

          <div class="d-flex mt-2">
            <span class="center">
              مهلت ارسال درخواست ماموریت در روز های تعطیل رسمی از ساعت</span
            >

            <dialog-time-picker
              class="mx-2"
              :label="$t('time') + ':'"
              :initTime="txtMissionsOffDaysLimitationStartTime"
              @dateResult="MissionsOffDaysLimitationStartTime"
            />
            <span class="center">تا ساعت</span>
            <dialog-time-picker
              class="mx-2"
              :label="$t('time') + ':'"
              :initTime="txtMissionsOffDaysLimitationEndTime"
              @dateResult="MissionsOffDaysLimitationEndTime"
            />
            <span class="center"> خواهد بود </span>
          </div>

          <div class="d-flex mt-2">
            <span class="center">
              مهلت ارسال درخواست ماموریت در روز های تعطیل توافقی از ساعت</span
            >
            <dialog-time-picker
              class="mx-2"
              :label="$t('time') + ':'"
              :initTime="txtMissionsAgreementOffDaysLimitationStartTime"
              @dateResult="MissionsAgreementOffDaysLimitationStartTime"
            />
            <span class="center">تا ساعت</span>
            <dialog-time-picker
              class="mx-2"
              :label="$t('time') + ':'"
              :initTime="txtMissionsAgreementOffDaysLimitationEndTime"
              @dateResult="MissionsAgreementOffDaysLimitationEndTime"
            />
            <span class="center"> خواهد بود </span>
          </div>

          <v-divider class="my-3" />

          <div class="d-flex flex-wrap">
            <span class="center">مهلت تایید درخواست مرخصی</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtDeadLineVacationConfirm"
            />
            <span class="center"
              >روز بعد از تاریخ درخواست مرخصی است. پس از پایان مهلت تایید یک
              برگه و عدم تایید آن، وضعیت برگه</span
            >
            <v-select
              hide-details
              v-model="ddlVacationstatus"
              :items="requestStatus"
              item-text="Name"
              item-value="Code"
              dense
              solo
              class="smallSelectField mx-2 my-auto py-0"
            ></v-select>
            <span class="center"> خواهد بود.</span>
          </div>

          <div class="d-flex flex-wrap">
            <span class="center">مهلت تایید درخواست ماموریت</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtDeadLineMissionConfirm"
            />
            <span class="center"
              >روز بعد از تاریخ درخواست ماموریت است. پس از پایان مهلت تایید یک
              برگه و عدم تایید آن، وضعیت برگه</span
            >
            <v-select
              hide-details
              v-model="ddlMissionStatus"
              :items="requestStatus"
              item-text="Name"
              item-value="Code"
              dense
              solo
              class="smallSelectField mx-2 my-auto py-0"
            ></v-select>
            <span class="center"> خواهد بود.</span>
          </div>

          <div class="d-flex flex-wrap">
            <span class="center">مهلت تایید درخواست اضافه کاری</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtDeadLineEwConfirm"
            />
            <span class="center"
              >روز بعد از تاریخ درخواست اضافه کاری است. پس از پایان مهلت تایید
              یک برگه و عدم تایید آن، وضعیت برگه</span
            >
            <v-select
              hide-details
              v-model="ddlEwStatus"
              :items="requestStatus"
              item-text="Name"
              item-value="Code"
              dense
              solo
              class="smallSelectField mx-2 my-auto py-0"
            ></v-select>
            <span class="center"> خواهد بود.</span>
          </div>

          <div class="d-flex flex-wrap">
            <span class="center">مهلت تایید درخواست ورود و خروج</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtDeadLineIoConfirm"
            />
            <span class="center"
              >روز بعد از تاریخ درخواست ورود و خروج است. پس از پایان مهلت تایید
              یک برگه و عدم تایید آن، وضعیت برگه</span
            >
            <v-select
              hide-details
              v-model="ddlIoStatus"
              :items="requestStatus"
              item-text="Name"
              item-value="Code"
              dense
              solo
              class="smallSelectField mx-2 my-auto py-0"
            ></v-select>
            <span class="center"> خواهد بود.</span>
          </div>

          <v-divider class="my-3" />

          <v-checkbox
            dense
            hide-details="true"
            v-model="chkLimitForOrdinaryVaction"
            @click.stop=""
            class="checkbox-rtl text"
            label="محدودیت در تعداد و مدت زمان مرخصی های ساعتی فقط برای مرخصی ساعتی
              استحقاقی اعمال شود."
          />

          <v-checkbox
            dense
            hide-details="true"
            v-model="chkCheckIoInVacation"
            @click.stop=""
            class="checkbox-rtl text"
            label="محدودیت در ثبت مرخصی اول وقت، در صورت ثبت ورود اول وقت اعمال نشود"
          />

          <v-checkbox
            dense
            hide-details="true"
            v-model="chkInBeginTimeVacation"
            @click.stop=""
            class="checkbox-rtl text"
          >
            <template v-slot:label>
              <span>اعمال محدودیت اول وقت برای مرخصی های ساعتی تا</span>
              <v-text-field
                :disabled="!chkInBeginTimeVacation"
                placeholder="0"
                class="smallTextField mx-2"
                dense
                solo
                hide-details=""
                v-model="txtTeloranceForBeginTimeVacation"
                @click.stop=""
              />
              <span>دقیقه بعد از زمان شروع کار</span>
            </template>
          </v-checkbox>

          <v-checkbox
            dense
            hide-details="true"
            v-model="chkCheckBeginVacationConflict"
            @click.stop=""
            class="checkbox-rtl text"
          >
            <template v-slot:label>
              <span>
                مرخصی ساعتی در صورت تداخل با بازه اول وقت ، مرخصی اول وقت حساب
                شود</span
              >
            </template>
          </v-checkbox>

          <v-checkbox
            dense
            hide-details="true"
            v-model="chkCheckBeginTimeVacationForNextDays"
            @click.stop=""
            class="checkbox-rtl text"
            label="محدودیت در ثبت مرخصی اول وقت، برای درخواست مرخصی های بعد از روز جاری اعمال نشود"
          />

          <div class="d-flex flex-wrap">
            <span class="center text"
              >تعداد مرخصی های اول وقت ساعتی درخواستی در یک دوره/ماه، نباید
              بیشتر از</span
            >
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtBeginTimeVacationCount"
            />
            <span class="center text">باشد</span>
          </div>

          <div class="d-flex flex-wrap">
            <span class="center text"
              >تعداد مرخصی های ساعتی درخواستی در یک دوره/ماه، نباید بیشتر
              از</span
            >
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtVacationCount"
            />
            <span class="center text">باشد</span>
          </div>

          <v-checkbox
            dense
            hide-details="true"
            v-model="chkCheckIoInMission"
            @click.stop=""
            class="checkbox-rtl text"
            label="محدودیت در ثبت ماموریت اول وقت، در صورت ثبت ورود اول وقت اعمال نشود"
          />

          <v-checkbox
            dense
            hide-details="true"
            v-model="chkInBeginTimeMission"
            @click.stop=""
            class="checkbox-rtl text"
          >
            <template v-slot:label>
              <span>اعمال محدودیت اول وقت برای ماموریت های ساعتی تا</span>
              <v-text-field
                :disabled="!chkInBeginTimeMission"
                placeholder="0"
                class="smallTextField mx-2"
                dense
                solo
                hide-details=""
                v-model="txtTeloranceForBeginTimeMission"
                @click.stop=""
              />
              <span>دقیقه بعد از زمان شروع کار</span>
            </template>
          </v-checkbox>

          <v-checkbox
            dense
            hide-details="true"
            v-model="chkCheckBeginTimeMissionForNextDays"
            @click.stop=""
            class="checkbox-rtl text"
            label="محدودیت در ثبت ماموریت اول وقت، برای درخواست ماموریت های بعد از روز جاری اعمال نشود"
          />

          <div class="d-flex flex-wrap">
            <span class="center text"
              >تعداد ماموریت های اول وقت ساعتی درخواستی در یک دوره/ماه، نباید
              بیشتر از</span
            >
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtBeginTimeMissionCount"
            />
            <span class="center text">باشد</span>
          </div>

          <div class="d-flex flex-wrap">
            <span class="center text"
              >تعداد ماموریت های ساعتی درخواستی در یک دوره/ماه، نباید بیشتر
              از</span
            >
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtMissionCount"
            />
            <span class="center text">باشد</span>
          </div>

          <div class="d-flex flex-wrap">
            <span class="center text">حداکثر مرخصی ساعتی در سال : </span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtMaxHourlyVacationPerYear"
            />
          </div>

          <v-divider class="my-3" />

          <div class="d-flex flex-wrap">
            <span class="center">کارکنان جدید تا</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtDayAfterEmployee"
            />
            <span class="center">
              روز پس از تاریخ استخدام امکان مشاهده منوی درخواست ها را نداشته
              باشند.</span
            >
          </div>

          <div class="d-flex flex-wrap">
            <span class="center">اجازه درخواست مرخصی تا مقدار مانده مرخصی</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtMaxVacation"
            />
            <span class="center"> دقیقه .</span>
          </div>

          <div class="d-flex flex-wrap">
            <span class="center"
              >مجموع ساعات مرخصی های ساعتی درخواستی در یک روز، نباید بیشتر
              از</span
            >
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtMaxMorInDay"
            />
            <span class="center"> دقیقه باشد.</span>
          </div>

          <div class="d-flex flex-wrap">
            <span class="center"
              >مجموع ساعات مرخصی های ساعتی درخواستی در یک دوره/ماه، نباید بیشتر
              از</span
            >
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtMaxMorInPeriod"
            />
            <span class="center"> دقیقه باشد.</span>
          </div>

          <div class="d-flex flex-wrap">
            <span class="center">مدت زمان یک ماموریت ساعتی نباید بیش از </span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtLimitOnTimmingMissionLength"
            />
            <span class="center"> دقیقه باشد.</span>
          </div>

          <div class="d-flex flex-wrap">
            <span class="center"
              >مجموع ساعات ماموریت های ساعتی درخواستی در یک روز، نباید بیشتر از
            </span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtMaxMisInDay"
            />
            <span class="center"> دقیقه باشد.</span>
          </div>

          <div class="d-flex flex-wrap">
            <span class="center">افرادی که از ابتدای سال جاری</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtMotavaliDay"
            />
            <span class="center">روز متوالی یا</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtMotanavebDay"
            />
            <span class="center">
              روز متناوب، ساعت ورود ندارد به صورت اتوماتیک استخراج شوند و به
              مدیران قسمت ها نمایش داده شوند.</span
            >
          </div>

          <div class="d-flex flex-wrap">
            <span class="center">پرسنل اجازه ثبت بیش از</span>
            <v-text-field
              placeholder="0"
              class="smallTextField mx-2"
              dense
              solo
              hide-details=""
              v-model="txtIoRequestNumber"
            />
            <span class="center"
              >برگه ورود و خروج را در ماه/دوره نداشته باشند.</span
            >
          </div>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="mx-1"
            color="primary"
            @click="btnChangeSettingClick"
            :loading="loadingChangeSetting"
            >اعمال تغییرات</v-btn
          >
          <v-btn class="mx-1" color="primary" @click="btnSetPermissionClick"
            >تنظیم دسترسی ها</v-btn
          >
        </v-card-actions>
      </box>
    </div>
  </div>
</template>

<script>
import ThemeChanger from "../../../components/widget/ThemeChanger.vue";
import EosToastType from "../../../model/EosToastType";
import DialogTimePicker from "../../../components/widget/DialogTimePicker.vue";
import ResultType from "../../../model/ResultType";
import EosUtils from "../../../utils/EosUtils";
export default {
  components: {
    ThemeChanger,
    DialogTimePicker,
  },
  data() {
    return {
      themeName: "",
      // rblLoginType: "",
      flagFailAnyResult: false,
      loadingChangeSetting: false,
      vacationTypes: [],
      selectedVacationTypes: [],
      missionTypes: [],
      selectedMissionTypes: [],
      selectedCity: "",
      missionCities: [],
      txtVacationPreDays: "",
      txtVacationNextDays: "",
      txtMissionPreDays: "",
      txtMissionNextDays: "",
      txtExtraWorkPreDay: "",
      txtExtraWorkNextDay: "",
      txtIoNextDay: "",
      txtDeadLineVacationConfirm: "",
      ddlVacationstatus: "10",
      txtDeadLineMissionConfirm: "",
      ddlMissionStatus: "10",
      txtDeadLineEwConfirm: "",
      ddlEwStatus: "10",
      txtDeadLineIoConfirm: "",
      ddlIoStatus: "10",
      txtBeginTimeVacationCount: "",
      txtVacationCount: "",
      txtBeginTimeMissionCount: "",
      txtMissionCount: "",
      txtMaxHourlyVacationPerYear: "",
      txtDayAfterEmployee: "",
      // changePasswordAfterDays:"",
      txtMaxVacation: "",
      txtMaxMorInDay: "",
      txtMaxMorInPeriod: "",
      txtLimitOnTimmingMissionLength: "",
      txtMaxMisInDay: "",
      txtMotavaliDay: "",
      txtMotanavebDay: "",
      txtTeloranceForBeginTimeVacation: "",
      txtTeloranceForBeginTimeMission: "",
      txtIoRequestNumber: "",
      txtExtraWorkOffDaysLimitationStartTime: "",
      txtExtraWorkOffDaysLimitationEndTime: "",
      txtExtraWorkAgreementOffDaysLimitationStartTime: "",
      txtExtraWorkAgreementOffDaysLimitationEndTime: "",
      txtExtraWorkWorkDaysLimitationStartTime: "",
      txtExtraWorkWorkDaysLimitationEndTime: "",
      txtMissionsOffDaysLimitationStartTime: "",
      txtMissionsOffDaysLimitationEndTime: "",
      txtMissionsAgreementOffDaysLimitationStartTime: "",
      txtMissionsAgreementOffDaysLimitationEndTime: "",
      txtMissionsWorkDaysLimitationStartTime: "",
      txtMissionsWorkDaysLimitationEndTime: "",

      requestStatus: [
        { Name: "تایید شده", Code: "10" },
        { Name: "تایید نشده", Code: "1" },
        { Name: "تعلیق", Code: "11" },
      ],
      settingsDetailsModelList: {
        chkDayEvent: false,
        chkAlertBirthDay: false,
        chkMorInHoliday: false,
        chkMorAfterHoliday: false,
        chkDisableMorLeft: false,
        chkLastYearMorLeft: false,
        chkDisableMorRemaining: false,
        chSaveMissionTime: false,
        chkAllowIoInCurrentDay: false,
        chkCommentRequred: false,
        chkCommentRequredForExtraWork: false,
        chkCommentRequredForVacation: false,
        chkCommentRequredForIo: false,
        chkTransferMorakhasi: false,
        chkTransferMamoriat: false,
        chkClock: false,
        chkVacationUseWorkCalendar: false,
        AutoAcceptGeoIo: false,
        checkPicGeoIo: false,
        defaultCityCode: 0,
      },
      chkInBeginTimeVacation: false,
      chkCheckBeginVacationConflict: true,
      // hardPassword:false,
      chkCheckBeginTimeVacationForNextDays: false,
      chkInBeginTimeMission: false,
      chkCheckBeginTimeMissionForNextDays: false,
      chkCheckIoInVacation: false,
      chkCheckIoInMission: false,
      chkLimitForOrdinaryVaction: false,
      settingsDetailsList: [
        { Name: "تولد پرسنل اعلام شود", Model: "chkAlertBirthDay" },
        { Name: "مناسبت ها نمایش داده شود", Model: "chkDayEvent" },
        {
          Name: "مرخصی ها توسط winkart  منتقل شوند",
          Model: "chkTransferMorakhasi",
        },
        {
          Name: "ماموریت ها توسط Winkart منتقل شوند",
          Model: "chkTransferMamoriat",
        },
        {
          Name: "عدم امکان ثبت مرخصی هایی که ابتدا یا انتهای آن ها روز تعطیل باشد",
          Model: "chkMorInHoliday",
        },
        {
          Name: "عدم امکان ثبت مرخصی هایی که بعد از تعطیلات باشند در شرایطی که قبل از تعطیلات فرد درخواست مرخصی داشته باشد",
          Model: "chkMorAfterHoliday",
        },
        {
          Name: "عدم نمایش مانده مرخصی در فرم ها",
          Model: "chkDisableMorLeft",
        },
        {
          Name: "عدم استفاده از مانده مرخصی های سال گذشته ",
          Model: "chkLastYearMorLeft",
        },
        {
          Name: " نمایش مانده مرخصی تاکنون ",
          Model: "chkDisableMorRemaining",
        },
        {
          Name: "کاربر امکان انتخاب دستگاه ساعت در برگه ورود و خروج را داشته باشد.",
          Model: "chkClock",
        },
        {
          Name: "محاسبات روزها در عملیات ورود و خروج، مرخصی، ماموریت و اضافه کاری بر مبنای تقویم کاری پرسنل باشد.",
          Model: "chkVacationUseWorkCalendar",
        },
        {
          Name: "امکان ثبت ورود و خروج در روز جاری وجود داشته باشد",
          Model: "chkAllowIoInCurrentDay",
        },
        {
          Name: "امکان ثبت ساعت های ماموریت وجود داشته باشد",
          Model: "chSaveMissionTime",
        },
        {
          Name: "وارد کردن فیلد توضیحات برای برگه ماموریت اجباری باشد",
          Model: "chkCommentRequred",
        },
        {
          Name: "وارد کردن فیلد توضیحات برای برگه مجوز اضافه کار اجباری باشد",
          Model: "chkCommentRequredForExtraWork",
        },
        {
          Name: "وارد کردن فیلد توضیحات برای برگه مرخصی اجباری باشد",
          Model: "chkCommentRequredForVacation",
        },
        {
          Name: "وارد کردن فیلد توضیحات برای برگه ورود و خروج اجباری باشد",
          Model: "chkCommentRequredForIo",
        },
        {
          Name: "تایید خودکار ورود و خروج از طریق موقعیت جغرافیایی",
          Model: "AutoAcceptGeoIo",
        },
        // {
        //   Name: "الزامی بودن تاییدیه ورود و خروج از طریق موقعیت جغرافیای همراه عکس ",
        //   Model: "checkPicGeoIo",
        // },
      ],
    };
  },
  mounted() {
    this.pageLoad();
  },
  methods: {
    pageLoad() {
      this.LoadVacationType();
      this.LoadMissionType();
      this.SetVacations();
      this.SetMission();
      this.LoadCity();
      this.LoadSettingDetail();
      this.ReadTransferField();
      this.loadClock();
      this.SetVacationUseWorkCalendar();
    },
    ExtraWorkOffDaysLimitationStartTime(date) {
      if (!date) {
        console.log("date : is null", date);
      }
      this.txtExtraWorkOffDaysLimitationStartTime = date;
      console.log(
        "txtExtraWorkOffDaysLimitationStartTime : ",
        this.txtExtraWorkOffDaysLimitationStartTime
      );
      console.log("date : ", date);
    },
    ExtraWorkOffDaysLimitationEndTime(date) {
      this.txtExtraWorkOffDaysLimitationEndTime = date;
    },
    ExtraWorkWorkDaysLimitationStartTime(date) {
      this.txtExtraWorkWorkDaysLimitationStartTime = date;
    },
    ExtraWorkWorkDaysLimitationEndTime(date) {
      this.txtExtraWorkWorkDaysLimitationEndTime = date;
    },
    ExtraWorkAgreementOffDaysLimitationStartTime(date) {
      this.txtExtraWorkAgreementOffDaysLimitationStartTime = date;
    },
    ExtraWorkAgreementOffDaysLimitationEndTime(date) {
      this.txtExtraWorkAgreementOffDaysLimitationEndTime = date;
    },
    MissionsOffDaysLimitationStartTime(date) {
      if (!date) {
        console.log("date : is null", date);
      }
      this.txtMissionsOffDaysLimitationStartTime = date;
      console.log(
        "txtMissionsOffDaysLimitationStartTime : ",
        this.txtMissionsOffDaysLimitationStartTime
      );
      console.log("date : ", date);
    },
    MissionsOffDaysLimitationEndTime(date) {
      this.txtMissionsOffDaysLimitationEndTime = date;
    },
    MissionsWorkDaysLimitationStartTime(date) {
      this.txtMissionsWorkDaysLimitationStartTime = date;
    },
    MissionsWorkDaysLimitationEndTime(date) {
      this.txtMissionsWorkDaysLimitationEndTime = date;
    },
    MissionsAgreementOffDaysLimitationStartTime(date) {
      this.txtMissionsAgreementOffDaysLimitationStartTime = date;
    },
    MissionsAgreementOffDaysLimitationEndTime(date) {
      this.txtMissionsAgreementOffDaysLimitationEndTime = date;
    },
    loadClock() {
      this.$store.dispatch("getClockSelection").then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.settingsDetailsModelList.chkClock = result.data;
        }
      });
    },
    SetVacationUseWorkCalendar() {
      this.$store.dispatch("VacationUseWorkCalendar").then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.settingsDetailsModelList.chkVacationUseWorkCalendar =
            result.data;
        }
      });
    },
    ReadTransferField() {
      this.$store.dispatch("readSystemTable").then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          if (result.data.Table[0]?.MisTransfer == "1") {
            this.settingsDetailsModelList.chkTransferMamoriat = true;
          }
          if (result.data.Table[0]?.MorTransfer == "1") {
            this.settingsDetailsModelList.chkTransferMorakhasi = true;
          }
        }
      });
    },
    LoadVacationType() {
      this.$store.dispatch("GetAllVacationTypeList").then((result) => {
        //console.log(result);
        ////debugger
        if (result.type === ResultType.success) {
          this.vacationTypes = result.data.Table;
          console.log("LoadVacationType:" + this.vacationTypes);
          //debugger
        }
      });
    },
    SetVacations() {
      this.$store.dispatch("GetWebVacationTypeList").then((response) => {
        if (response.type === "success") {
          ////debugger
          this.selectedVacationTypes = response.data.map((item) => item.Code);
          console.log("SetVacations" + this.selectedVacationTypes);
        }
      });
    },
    LoadMissionType() {
      this.$store.dispatch("GetAllMissionTypeList").then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.missionTypes = result.data.Table;
        }
      });
    },
    SetMission() {
      this.$store.dispatch("GetWebMissionTypeList").then((response) => {
        if (response.type === "success") {
          this.selectedMissionTypes = response.data.map((item) => item.Code);
        }
      });
      /*
        var newDataSet = Mission.WebMissionList();
            for (var i = 0; i < chkWebMission.Items.Count; i++)
            {
                for (var j = 0; j < newDataSet.Tables[0].Rows.Count; j++)
                {
                    if (j > chkWebMission.Items.Count) continue;
                    if (chkWebMission.Items[i].Value == newDataSet.Tables[0].Rows[j][1].ToString())
                    {
                        chkWebMission.Items[i].Selected = true;
                    }
                }
            }
        */
    },
    LoadCity() {
      this.$store.dispatch("GetMissionCityList").then((response) => {
        if (response.type === ResultType.success) {
          this.missionCities = response.data;
          var aa = response.data;

          if (this.missionCities.length > 0) {
            //debugger
            console.log("city:" + aa[1]);
            var defaultCityCodeToInt = parseInt(this.defaultCityCode);
            if (defaultCityCodeToInt != 0) {
              localStorage.removeItem("CityCode");
              localStorage.setItem("CityCode", defaultCityCodeToInt);
              var valObj = this.missionCities.find(
                (s) => s.Code === defaultCityCodeToInt
              );

              console.log("result obj" + valObj);

              // this.selectedCity = this.defaultCityCode;
              this.selectedCity = valObj;
            } else {
              this.selectedCity = this.missionCities[0];
            }

            // this.GetDefaultCity();
          }
        }
      });
    },
    GetDefaultCity() {
      console.log(this.defaultCityCode);
      this.LoadCity();
    },

    LoadSettingDetail() {
      this.$store.dispatch("readwebkartsetting").then((result) => {
        if (result.type === ResultType.success) {
          debugger;

          var ws = result.data;
          this.settingsDetailsModelList.chkDayEvent = ws.ShowEvent == "1";
          this.settingsDetailsModelList.chkAlertBirthDay =
            ws.ShowBirthDay == "1";
          this.settingsDetailsModelList.chkMorInHoliday =
            ws.CanNotAddMorInHoliday == "1";
          this.settingsDetailsModelList.chkMorAfterHoliday =
            ws.CanNotAddMorAfterHoliday == "1";
          this.settingsDetailsModelList.chkDisableMorLeft =
            ws.DisableShowingMorLeft == "1";
          this.settingsDetailsModelList.chkLastYearMorLeft =
            ws.LastYearMorLeft == "1";
          this.settingsDetailsModelList.chkDisableMorRemaining =
            ws.DisableShowingMorRemaining == "1";
          this.settingsDetailsModelList.chSaveMissionTime =
            ws.SaveMissionTime == "1";

          this.settingsDetailsModelList.chkAllowIoInCurrentDay =
            ws.AllowIoInCurrentDay == "1";
          this.settingsDetailsModelList.chkCommentRequred =
            ws.IsCommentRequired == "1";
          this.settingsDetailsModelList.chkCommentRequredForExtraWork =
            ws.IsCommentRequiredForExtraWork == "1";
          this.settingsDetailsModelList.chkCommentRequredForVacation =
            ws.IsCommentRequiredForVacation == "1";
          this.settingsDetailsModelList.chkCommentRequredForIo =
            ws.IsCommentRequiredForIo == "1";
          this.settingsDetailsModelList.hkInBeginTimeVacation =
            ws.InBeginTimeVacation == "1";
          this.settingsDetailsModelList.AutoAcceptGeoIo = ws.AutoAcceptGeoIo;
          this.settingsDetailsModelList.checkPicGeoIo = ws.checkPicGeoIo;

          this.chkCheckBeginTimeVacationForNextDays =
            ws.CheckBeginTimeVacationForNextDays;
          this.chkCheckBeginVacationConflict = ws.CheckBeginVacationConflict;
          // this.hardPassword =
          //   ws.HardPassword;
          this.chkInBeginTimeMission = ws.InBeginTimeMission == "1";
          this.chkInBeginTimeVacation = ws.InBeginTimeVacation == "1";
          this.chkCheckBeginTimeMissionForNextDays =
            ws.CheckBeginTimeMissionForNextDays;
          this.chkCheckIoInVacation = ws.CheckIoForFirstTimeVacation == "1";
          this.chkCheckIoInMission = ws.CheckIoForFirstTimeMission == "1";
          this.chkLimitForOrdinaryVaction = ws.LimitForOrdinaryVacation == "1";

          this.txtVacationPreDays = ws.VacationPreDay;
          this.txtVacationNextDays = ws.VacationEndDay;
          this.defaultCityCode = ws.DefaultCityCode;
          //debugger
          this.GetDefaultCity();
          //txtMaxHourlyVacationPerYear = EosUtility.ConvertMinuteToHour3Section(ws.MaxhourlyVacationPerYear.ToString());
          this.txtMaxHourlyVacationPerYear = EosUtils.ConvertMinToHour(
            ws.MaxhourlyVacationPerYear
          );

          //در صورتی که اجازه ثبت ورود و خروج در روز جاری را نداشته باشد
          // و از قبل صفر در فیلد نشان دهنده تعداد روزی که شخص میتواند ورود و خروج خود را ثبت کند درج شده باشد
          //رشته خالی را به عنوان مقدار پیش فرض نمایش میدهد
          this.txtIoNextDay =
            ws.AllowIoInCurrentDay == "0" && ws.IoEndDay == "0"
              ? ""
              : ws.IoEndDay;

          this.txtDayAfterEmployee = ws.EnableAccessAfterDay;
          this.txtMaxMorInDay = ws.MaxMorInDay;
          // this.changePasswordAfterDays=ws.ChangePasswordAfterDays
          this.txtMotanavebDay = ws.MotanavebDay;
          this.txtMotavaliDay = ws.MotavaliDay;

          this.txtMaxMisInDay = ws.MaxMisInDay;

          this.txtMaxMorInPeriod = ws.MaxMorInPeriod;
          this.txtIoRequestNumber = ws.MaxIoRequestInPeriod;

          this.txtExtraWorkOffDaysLimitationEndTime =
            ws.ExtraWorkOffDaysLimitationEndTime;
          this.txtExtraWorkOffDaysLimitationStartTime =
            ws.ExtraWorkOffDaysLimitationStartTime;
          this.txtExtraWorkAgreementOffDaysLimitationStartTime =
            ws.ExtraWorkAgreementOffDaysLimitationStartTime;
          this.txtExtraWorkAgreementOffDaysLimitationEndTime =
            ws.ExtraWorkAgreementOffDaysLimitationEndTime;
          this.txtExtraWorkWorkDaysLimitationStartTime =
            ws.ExtraWorkWorkDaysLimitationStartTime;
          this.txtExtraWorkWorkDaysLimitationEndTime =
            ws.ExtraWorkWorkDaysLimitationEndTime;

          this.txtMissionsOffDaysLimitationEndTime =
            ws.MissionsOffDaysLimitationEndTime;
          this.txtMissionsOffDaysLimitationStartTime =
            ws.MissionsOffDaysLimitationStartTime;
          this.txtMissionsAgreementOffDaysLimitationStartTime =
            ws.MissionsAgreementOffDaysLimitationStartTime;
          this.txtMissionsAgreementOffDaysLimitationEndTime =
            ws.MissionsAgreementOffDaysLimitationEndTime;
          this.txtMissionsWorkDaysLimitationStartTime =
            ws.MissionsWorkDaysLimitationStartTime;
          this.txtMissionsWorkDaysLimitationEndTime =
            ws.MissionsWorkDaysLimitationEndTime;

          this.txtMissionPreDays = ws.MissionPreDay;
          this.txtMissionNextDays = ws.MissionNextDay;
          this.txtExtraWorkPreDay = ws.ExtraWorkPreDay;
          this.txtExtraWorkNextDay = ws.ExtraWorkNexDay;

          this.txtBeginTimeMissionCount = ws.BeginTimeMissionCount;
          this.txtBeginTimeVacationCount = ws.BeginTimeVacationCount;

          //جهت اعمال محدودیت در تعداد ماموریت ها و مرخصی های ساعتی در یک دوره یا ماه
          // که در صورتی که مقدار برای این فیلد درح نشود این محدودیت اعمال نمی شود
          this.txtMissionCount = ws.MissionCount;
          this.txtVacationCount = ws.VacationCount;

          //زمانیکه که اجازه ثبت مرخصی در صورت منفی شدن مانده مرخصی ها (سقف مانده مرخصی) وجود داشته باشد
          //و از قبل مقداری برای مقدار مجوز مانده مرخصی ثبت نشده باشد
          //مقدار پیش فرض را برای این فیلد صفر در نظر گرفته و نمایش می دهد
          this.txtMaxVacation = ws.MaxVacation;

          this.txtTeloranceForBeginTimeVacation =
            ws.TeloranceForBeginTimeVacation;
          this.txtTeloranceForBeginTimeMission =
            ws.TeloranceForBeginTimeMission;
          this.txtLimitOnTimmingMissionLength = ws.LimitOnTimmingMissionLength;

          //تعیین مهلت تایید برای برگه های ماموریت، مرخصی، اضافه کاری و ورود و خروج
          // و تعیین وضعیت برگه های تایید نشده پس از پایان مهلت تایید
          this.txtDeadLineEwConfirm =
            ws.DeadLineConfirmExtraWork == "0"
              ? null
              : ws.DeadLineConfirmExtraWork.toString();
          this.txtDeadLineIoConfirm =
            ws.DeadLineConfirmIo == "0"
              ? null
              : ws.DeadLineConfirmIo.toString();
          this.txtDeadLineMissionConfirm =
            ws.DeadLineConfirmMission == "0"
              ? null
              : ws.DeadLineConfirmMission.toString();
          this.txtDeadLineVacationConfirm =
            ws.DeadLineConfirmVacation == "0"
              ? null
              : ws.DeadLineConfirmVacation.toString();
          this.ddlEwStatus = ws.EwStatusAfterDeadLine;
          this.ddlIoStatus = ws.IoStatusAfterDeadLine;
          this.ddlMissionStatus = ws.MisStatusAfterDeadLine;
          this.ddlVacationstatus = ws.VacStatusAfterDeadLine;

          //this.$forceUpdate();
          // var psw=this.hardPassword?1:0
          // psw.toString();
          // localStorage.setItem("Pws",psw)
        }
      });
    },
    btnSetPermissionClick() {
      this.$router.push({ name: "publicAccess" });
    },
    async btnChangeSettingClick() {
      var misTransfer = this.settingsDetailsModelList.chkTransferMamoriat
        ? "1"
        : "0";
      var morTransfer = this.settingsDetailsModelList.chkTransferMorakhasi
        ? "1"
        : "0";
      var canNotAddMorInHoliday = this.settingsDetailsModelList.chkMorInHoliday
        ? "1"
        : "0";
      var canNotAddMorAfterHoliday = this.settingsDetailsModelList
        .chkMorAfterHoliday
        ? "1"
        : "0";
      var disableLeftMor = this.settingsDetailsModelList.chkDisableMorLeft
        ? "1"
        : "0";
      var lastYearMorLeft = this.settingsDetailsModelList.chkLastYearMorLeft
        ? "1"
        : "0";
      var disableMorRemaining = this.settingsDetailsModelList
        .chkDisableMorRemaining
        ? "1"
        : "0";
      var saveMissionTime = this.settingsDetailsModelList.chSaveMissionTime
        ? "1"
        : "0";
      var commentRequired = this.settingsDetailsModelList.chkCommentRequred
        ? "1"
        : "0";
      var commentRequiredForExtraWork = this.settingsDetailsModelList
        .chkCommentRequredForExtraWork
        ? "1"
        : "0";
      var commentRequiredForVacation = this.settingsDetailsModelList
        .chkCommentRequredForVacation
        ? "1"
        : "0";
      var commentRequiredForIo = this.settingsDetailsModelList
        .chkCommentRequredForIo
        ? "1"
        : "0";
      var inBeginTimeVacation = this.chkInBeginTimeVacation ? "1" : "0";
      var checkBeginTimeVacationForNextDays =
        this.chkCheckBeginTimeVacationForNextDays;
      var checkBeginVacationConflict = this.chkCheckBeginVacationConflict;
      // var hardPassword=
      // this.hardPassword;
      var inBeginTimeMission = this.chkInBeginTimeMission ? "1" : "0";
      var checkBeginTimeMissionForNextDays =
        this.chkCheckBeginTimeMissionForNextDays;
      var checkIoInMission = this.chkCheckIoInMission ? "1" : "0";
      var checkIoInVacation = this.chkCheckIoInVacation ? "1" : "0";
      var limitForOrdinaryVacation = this.chkLimitForOrdinaryVaction
        ? "1"
        : "0";
      var maxHourlyVacationPerYear = EosUtils.ConvertHourMinToMin(
        this.txtMaxHourlyVacationPerYear
      );

      //در صورتی که امکان ثبت ورود و خروج در روز جاری وجود نداشته باشد
      //مقدار تعداد روزی که می توان ورود و خروج خود را ثبت کند برابر با صفر باشد
      if (
        !this.settingsDetailsModelList.chkAllowIoInCurrentDay &&
        this.txtIoNextDay &&
        Number(this.txtIoNextDay) == 0
      ) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: "درج عدد صفر با توجه به اینکه اجازه ثبت ورود و خروج در روز جاری وجود ندارد، امکان پذیر نیست",
        });
        return;
      }

      if (!this.txtMotavaliDay && this.txtMotanavebDay) {
        //lblError.Text = eosWinKartWebResource.MotavaliMotanavebRelationError;
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("MotavaliMotanavebRelationError"),
        });
        return;
      }
      if (this.txtMotavaliDay && !this.txtMotanavebDay) {
        //lblError.Text = eosWinKartWebResource.MotavaliMotanavebRelationError;
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("MotavaliMotanavebRelationError"),
        });
        return;
      }

      this.loadingChangeSetting = true;

      var res = await Promise.all([
        this.WriteSystemTable(misTransfer, morTransfer),
        this.AddDefaultCity(),
        this.UpdateEventFlag(),
        this.UpdateBirthDayFlag(),
        this.UpdateAllowIoInCurrentDay(),
        this.UpdateMisApproveType(),
        this.UpdateMorApproveType(),
        this.UpdateLimitationDays(),
        this.UpdateExtraWorkLimitation(),
        this.UpdateMissionsLimitation(),
        this.UpdateSomeAddedField(
          canNotAddMorInHoliday,
          canNotAddMorAfterHoliday,
          disableLeftMor,
          lastYearMorLeft,
          disableMorRemaining,
          saveMissionTime,
          commentRequired,
          commentRequiredForExtraWork,
          commentRequiredForVacation,
          commentRequiredForIo,
          inBeginTimeVacation,
          inBeginTimeMission,
          checkIoInVacation,
          checkIoInMission,
          limitForOrdinaryVacation,
          maxHourlyVacationPerYear,
          checkBeginTimeVacationForNextDays,
          checkBeginVacationConflict,
          // hardPassword,
          checkBeginTimeMissionForNextDays
        ),
        this.UpdateClock(),
        this.updateVacationCalendar(),
        // this.updatePasswordSetting(),
      ]);
      console.log(res);
      if (!this.flagFailAnyResult) {
        this.$EosToast.show({
          type: EosToastType.success,
          msg: this.$t("operationSuccess"),
        });
      }

      this.loadingChangeSetting = false;
      console.log("this.loadingChangeSetting", this.loadingChangeSetting);
    },
    async UpdateMisApproveType() {
      // return await Promise.all([
      //   this.TruncateApprovedMission(),
      //   // setTimeout(this.AddApproveMission(),1000),
      //   this.AddApproveMission(),
      // ]);
      //debugger

      var missionCode = this.selectedMissionTypes;
      this.$store.dispatch("SetWebMissions", { missionCode }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          //
        } else {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: result.error || this.$t("operationFailed"),
          });
          this.flagFailAnyResult = true;
        }
      });
    },
    async AddApproveMission() {
      return this.selectedMissionTypes.forEach((element) => {
        var missionCode = element;
        this.$store
          .dispatch("AddApproveMission", { missionCode })
          .then((result) => {
            //console.log(result);
            if (result.type === ResultType.success) {
              //
            } else {
              this.$EosToast.show({
                type: EosToastType.error,
                msg: result.error || this.$t("operationFailed"),
              });
              this.flagFailAnyResult = true;
            }
          });
      });
    },
    async TruncateApprovedMission() {
      return this.$store.dispatch("TruncateApprovedMission").then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          //
        } else {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: result.error || this.$t("operationFailed"),
          });
          this.flagFailAnyResult = true;
        }
      });
    },
    async UpdateMorApproveType() {
      // return Promise.all([
      // this.TruncateApprovedVacation(),
      // setTimeout(this.AddApproveVacation(),1000),
      // this.AddApproveVacation(),
      // ]);
      //add
      // this.selectedVacationTypes.forEach((element) => {
      // var vacationCode = this.selectedVacationTypes;
      // let vacationCode =[];

      // this.selectedVacationTypes.forEach((element) => {
      //   vacationCode.push(element);
      // });
      var vacationCode = this.selectedVacationTypes;

      //debugger;
      this.$store
        .dispatch("SetWebVacations", { vacationCode })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            ////debugger
            //
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
            this.flagFailAnyResult = true;
          }
        });
      // });
    },
    async AddApproveVacation() {
      console.log("AddApproveVacation:" + this.selectedVacationTypes);

      return this.selectedVacationTypes.forEach((element) => {
        var vacationCode = element;
        this.$store
          .dispatch("AddApproveVacation", { vacationCode })
          .then((result) => {
            //console.log(result);
            if (result.type === ResultType.success) {
              ////debugger
              //
            } else {
              this.$EosToast.show({
                type: EosToastType.error,
                msg: result.error || this.$t("operationFailed"),
              });
              this.flagFailAnyResult = true;
            }
          });
      });
    },
    async TruncateApprovedVacation() {
      return this.$store.dispatch("TruncateApprovedVacation").then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          //
        } else {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: result.error || this.$t("operationFailed"),
          });
          this.flagFailAnyResult = true;
        }
      });
    },
    async WriteSystemTable(misTransfer, morTransfer) {
      return this.$store
        .dispatch("WriteSystemTable", { misTransfer, morTransfer })
        .then((result) => {
          console.log(result);
          if (result.type === ResultType.success) {
            //
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
            this.flagFailAnyResult = true;
          }
        });
    },
    async AddDefaultCity() {
      if (!this.selectedCity.Code) {
        return;
      }

      var citycode = this.selectedCity.Code;
      return this.$store
        .dispatch("AddDefaultCity", { citycode })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            //
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
            this.flagFailAnyResult = true;
          }
        });
    },
    async UpdateEventFlag() {
      var showEvent = this.settingsDetailsModelList.chkDayEvent ? "1" : "0";
      this.$store.dispatch("UpdateEventFlag", { showEvent }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          //
        } else {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: result.error || this.$t("operationFailed"),
          });
          this.flagFailAnyResult = true;
        }
      });
    },
    async UpdateBirthDayFlag() {
      var birthDayFlag = this.settingsDetailsModelList.chkAlertBirthDay
        ? "1"
        : "0";
      this.$store
        .dispatch("UpdateBirthDayFlag", { birthDayFlag })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            //
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
            this.flagFailAnyResult = true;
          }
        });
    },
    async UpdateAllowIoInCurrentDay() {
      var allow = this.settingsDetailsModelList.chkAllowIoInCurrentDay
        ? "1"
        : "0";
      this.$store
        .dispatch("UpdateAllowIoInCurrentDay", { allow })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            //
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
            this.flagFailAnyResult = true;
          }
        });
    },
    async UpdateLimitationDays() {
      var UpdateLimitationDaysData = {
        vacationPreDay: this.txtVacationPreDays,
        vacationEndDay: this.txtVacationNextDays,
        ioEndDay: this.txtIoNextDay,
        enableAfterEmployee: this.txtDayAfterEmployee,
        maxMorInDay: this.txtMaxMorInDay,
        motanavebDay: this.txtMotanavebDay,
        motavaliDay: this.txtMotavaliDay,
        maxIoRequestInPeriod: this.txtIoRequestNumber,
        maxMorInPeriod: this.txtMaxMorInPeriod,
        missionPreday: this.txtMissionPreDays,
        missionNextDay: this.txtMissionNextDays,
        extraworkPreDay: this.txtExtraWorkPreDay,
        extraWorkNextDay: this.txtExtraWorkNextDay,
        maxVacation: this.txtMaxVacation,
        ewStatusAfterDeadLine: this.ddlEwStatus,
        ioStatusAfterDeadLine: this.ddlIoStatus,
        vacStatusAfterDeadLine: this.ddlVacationstatus,
        misStatusAfterDeadLine: this.ddlMissionStatus,
        deadLineConfirmExtraWork: this.txtDeadLineEwConfirm,
        deadLineConfirmIo: this.txtDeadLineIoConfirm,
        deadLineConfirmVacation: this.txtDeadLineVacationConfirm,
        deadLineConfirmMission: this.txtDeadLineMissionConfirm,
        missionCount: this.txtMissionCount,
        vacationCount: this.txtVacationCount,
        teloranceForBeginTimeVacation: this.txtTeloranceForBeginTimeVacation,
        teloranceForBeginTimeMission: this.txtTeloranceForBeginTimeMission,
        limitOnTimmingMissionLength: this.txtLimitOnTimmingMissionLength,

        extraWorkOffDaysLimitationStartTime:
          this.txtExtraWorkOffDaysLimitationStartTime,
        extraWorkOffDaysLimitationEndTime:
          this.txtExtraWorkOffDaysLimitationEndTime,
        extraWorkAgreementOffDaysLimitationStartTime:
          this.txtExtraWorkAgreementOffDaysLimitationStartTime,
        extraWorkAgreementOffDaysLimitationEndTime:
          this.txtExtraWorkAgreementOffDaysLimitationEndTime,
        extraWorkWorkDaysLimitationStartTime:
          this.txtExtraWorkWorkDaysLimitationStartTime,
        extraWorkWorkDaysLimitationEndTime:
          this.txtExtraWorkWorkDaysLimitationEndTime,

        missionsOffDaysLimitationStartTime:
          this.txtMissionsOffDaysLimitationStartTime,
        missionsOffDaysLimitationEndTime:
          this.txtMissionsOffDaysLimitationEndTime,
        missionsAgreementOffDaysLimitationStartTime:
          this.txtMissionsAgreementOffDaysLimitationStartTime,
        missionsAgreementOffDaysLimitationEndTime:
          this.txtMissionsAgreementOffDaysLimitationEndTime,
        missionsWorkDaysLimitationStartTime:
          this.txtMissionsWorkDaysLimitationStartTime,
        missionsWorkDaysLimitationEndTime:
          this.txtMissionsWorkDaysLimitationEndTime,

        maxMisInDay: this.txtMaxMisInDay,
        beginTimeVacationCount: this.txtBeginTimeVacationCount,
        beginTimeMissionCount: this.txtBeginTimeMissionCount,
        // changePasswordAfterDays: this.changePasswordAfterDays,
      };
      console.log(UpdateLimitationDaysData);
      debugger;
      return this.$store
        .dispatch("UpdateLimitationDays", { UpdateLimitationDaysData })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            //
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
            this.flagFailAnyResult = true;
          }
        });
    },
    async UpdateExtraWorkLimitation() {
      var UpdateExtraWorkLimitationData = {
        extraWorkOffDaysLimitationStartTime:
          this.txtExtraWorkOffDaysLimitationStartTime,
        extraWorkOffDaysLimitationEndTime:
          this.txtExtraWorkOffDaysLimitationEndTime,
        extraWorkAgreementOffDaysLimitationStartTime:
          this.txtExtraWorkAgreementOffDaysLimitationStartTime,
        extraWorkAgreementOffDaysLimitationEndTime:
          this.txtExtraWorkAgreementOffDaysLimitationEndTime,
        extraWorkWorkDaysLimitationStartTime:
          this.txtExtraWorkWorkDaysLimitationStartTime,
        extraWorkWorkDaysLimitationEndTime:
          this.txtExtraWorkWorkDaysLimitationEndTime,
      };
      console.log(
        "UpdateExtraWorkLimitationData : ",
        UpdateExtraWorkLimitationData
      );
      return this.$store
        .dispatch("UpdateExtraWorkLimitation", {
          UpdateExtraWorkLimitationData,
        })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            //
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
            this.flagFailAnyResult = true;
          }
        });
    },
    async UpdateMissionsLimitation() {
      var UpdateMissionsLimitationData = {
        missionsOffDaysLimitationStartTime:
          this.txtMissionsOffDaysLimitationStartTime,
        missionsOffDaysLimitationEndTime:
          this.txtMissionsOffDaysLimitationEndTime,
        missionsAgreementOffDaysLimitationStartTime:
          this.txtMissionsAgreementOffDaysLimitationStartTime,
        missionsAgreementOffDaysLimitationEndTime:
          this.txtMissionsAgreementOffDaysLimitationEndTime,
        missionsWorkDaysLimitationStartTime:
          this.txtMissionsWorkDaysLimitationStartTime,
        missionsWorkDaysLimitationEndTime:
          this.txtMissionsWorkDaysLimitationEndTime,
      };
      console.log(
        "UpdateMissionsLimitationData : ",
        UpdateMissionsLimitationData
      );
      return this.$store
        .dispatch("UpdateMissionsLimitation", { UpdateMissionsLimitationData })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            //
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
            this.flagFailAnyResult = true;
          }
        });
    },
    async UpdateSomeAddedField(
      canNotAddMorInHoliday,
      canNotAddMorAfterHoliday,
      disableLeftMor,
      lastYearMorLeft,
      disableMorRemaining,
      saveMissionTime,
      commentRequired,
      commentRequiredForExtraWork,
      commentRequiredForVacation,
      commentRequiredForIo,
      inBeginTimeVacation,
      inBeginTimeMission,
      checkIoInVacation,
      checkIoInMission,
      limitForOrdinaryVacation,
      maxHourlyVacationPerYear,
      checkBeginTimeVacationForNextDays,
      checkBeginVacationConflict,
      // hardPassword,
      checkBeginTimeMissionForNextDays
    ) {
      console.log("commentRequiredForExtraWork:" + commentRequiredForExtraWork);
      var UpdateSomeAddedFieldData = {
        canNotAddMorInHoliday: canNotAddMorInHoliday,
        canNotAddMorAfterHoliday: canNotAddMorAfterHoliday,
        disableLeftMor: disableLeftMor,
        lastYearMorLeft: lastYearMorLeft,
        disableMorRemaining: disableMorRemaining,
        saveMissionTime: saveMissionTime,
        commentRequired: commentRequired,
        commentRequiredForExtraWork: commentRequiredForExtraWork,
        commentRequiredForVacation: commentRequiredForVacation,
        commentRequiredForIo: commentRequiredForIo,
        inBeginTimeVacation: inBeginTimeVacation,
        inBeginTimeMission: inBeginTimeMission,
        checkIoInVacation: checkIoInVacation,
        checkIoInMission: checkIoInMission,
        limitForOrdinaryVacation: limitForOrdinaryVacation,
        maxhourlyVacationPerYear: maxHourlyVacationPerYear,
        checkBeginTimeVacationForNextDays: checkBeginTimeVacationForNextDays,
        checkBeginVacationConflict: checkBeginVacationConflict,
        // hardPassword:hardPassword,
        checkBeginTimeMissionForNextDays: checkBeginTimeMissionForNextDays,
        AutoAcceptGeoIo: this.settingsDetailsModelList.AutoAcceptGeoIo,
        checkPicGeoIo: this.settingsDetailsModelList.checkPicGeoIo,
      };
      debugger;

      localStorage.removeItem("ShowMorRemaining");

      localStorage.setItem(
        "ShowMorRemaining",
        UpdateSomeAddedFieldData.disableMorRemaining
      );
      return this.$store
        .dispatch("UpdateSomeAddedField", { UpdateSomeAddedFieldData })
        .then((result) => {
          console.log(result);
          if (result.type === ResultType.success) {
            //
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
            this.flagFailAnyResult = true;
          }
        });
    },
    async UpdateClock() {
      var UpdateClockAllowSelect = this.settingsDetailsModelList.chkClock;
      return this.$store
        .dispatch("UpdateClock", { UpdateClockAllowSelect })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            //
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
            this.flagFailAnyResult = true;
          }
        });
    },
    async updateVacationCalendar() {
      debugger;
      var isWorkCalendar =
        this.settingsDetailsModelList.chkVacationUseWorkCalendar;
      return this.$store
        .dispatch("updateVacationCalendar", { isWorkCalendar })
        .then((result) => {
          console.log(result);

          if (result.type === ResultType.success) {
            ////debugger
            //
           
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
            this.flagFailAnyResult = true;
          }
        });
    },
    // updatePasswordSetting(){
    //   var changedPasswordSetting =
    //     this.changedPasswordSetting;
    //   return this.$store
    //     .dispatch("updateVacationCalendar", { changedPasswordSetting })
    //     .then((result) => {
    //       //console.log(result);
    //       if (result.type === ResultType.success) {////debugger
    //         //
    //       } else {
    //         this.$EosToast.show({
    //           type: EosToastType.error,
    //           msg: result.error || this.$t("operationFailed"),
    //         });
    //         this.flagFailAnyResult = true;
    //       }
    //     });
    // },
    changeTheme() {
      this.$refs.ThemeChanger.show();
      ////debugger
    },
    themeChanged() {
      this.themeName = this.$vuetify.theme.themes.name;
      ////debugger
    },
    btnSaveClick() {
      ////debugger
      var colorAdminNum = this.$vuetify.theme.themes.colorNumber;

      localStorage.setItem("colorAdminNum", colorAdminNum);
      this.$store;
      // .dispatch("ChangeSetting", {
      //   params: {
      //     theme: "1",
      //     useActiveDirectory: "",
      //   },
      // })
      // .then((result) => {
      //   console.log(result);
      //   if (result.type === ResultType.success && result.data) {
      //     this.$EosToast.show({
      //       type: EosToastType.success,
      //       msg: this.$t("operationSuccess"),
      //     });
      //   } else {
      //     this.$EosToast.show({
      //       type: EosToastType.error,
      //       msg: result.error || this.$t("operationFailed"),
      //     });
      //   }
      // });

      this.$EosToast.show({
        type: EosToastType.success,
        msg: this.$t("operationSuccess"),
      });
      ////debugger
    },
  },
};
</script>

<style>
.smallTextField {
  max-width: 60px;
}
.smallSelectField {
  max-width: 150px;
}
</style>
